module.exports = __webpack_public_path__ + "static/media/enmovil_logo.ac75673d.png";